import { render, staticRenderFns } from "./VacancyListItemSocialDialog.vue?vue&type=template&id=35d1102d&scoped=true&"
import script from "./VacancyListItemSocialDialog.vue?vue&type=script&lang=js&"
export * from "./VacancyListItemSocialDialog.vue?vue&type=script&lang=js&"
import style0 from "./VacancyListItemSocialDialog.vue?vue&type=style&index=0&id=35d1102d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d1102d",
  null
  
)

/* custom blocks */
import block0 from "./VacancyListItemSocialDialog.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=ru"
if (typeof block0 === 'function') block0(component)
import block1 from "./VacancyListItemSocialDialog.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=en"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VCardText,VCardTitle,VDivider})
